// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"Search_suggestions__2CMpu","green":"Search_green__y9uGI","orange":"Search_orange__3SRVK","filter":"Search_filter__2rnEm","search":"Search_search__34g4P"};